<template>
  <div class="st-travel-sausage">
    <travel-sausage-badge
      :color="color"
      :icon-color="iconColor"
      :traffic-type="trafficType"
      :aria-hidden="badgeAriaHidden"
    />
    <span>
      <!-- need to add a '.' after 'm' for walk, otherwise screen reader doesn't understand the abbreviation -->
      {{ text }}{{ trafficType === "walk" ? "." : "" }}
    </span>
    <div v-if="isCanceled" class="st-travel-sausage__canceled-badge">
      <span> {{ canceledText }} </span>
    </div>
  </div>
</template>

<script>
import TravelSausageBadge from "./TravelSausageBadge.vue";
export default {
  name: "st-travel-sausage",
  props: {
    trafficType: String,
    text: String,
    color: String,
    iconColor: {
      type: String,
      default: "#3E3B39",
    },
    badgeAriaHidden: {
      type: Boolean,
      default: false,
    },
    isCanceled: {
      type: Boolean,
      default: false,
    },
    canceledText: {
      type: String,
      default: "Inställd",
    },
  },
  components: {
    TravelSausageBadge,
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

@mixin four40 {
  @media (max-width: 440px) {
    @content;
  }
}

.st-travel-sausage {
  display: flex;
  align-items: stretch;
  flex-direction: row;
  background-color: var(--palette-neutral-100);
  border-radius: rem-calc(4);
  font-family: var(--font-primary);
  font-weight: var(--font-weight-regular);
  font-size: rem-calc(18);
  line-height: rem-calc(24);
  color: var(--text-color-primary);
  height: auto;
  min-height: rem-calc(24);
  width: 100%;
  @include four40 {
    font-size: rem-calc(13);
  }

  & > *:not(:last-child) {
    margin-right: rem-calc(8);
  }

  &__canceled-badge {
    display: flex;
    align-items: center;
    white-space: nowrap;
    padding: 0 rem-calc(10);
    background-color: var(--brand-color-primary);
    color: var(--text-color-tertiary);
    margin-left: auto;
    border-radius: 0 rem-calc(4) rem-calc(4) 0;

    span {
      font-weight: var(--font-weight-semi-bold);
    }
  }
}
</style>
